// export const API_BASE_URL = 'http://localhost:4000';
export const API_BASE_URL = 'https://admin.maneliada.ro';

const credentials = {
    youtubeApiKey: "AIzaSyD8kmkEspsADwiGLK7pYc6O70QcaVlqXUo",
    playlistId: 'PL1oZTLoai-ScQols1zlzDltWLkDV_vCU7'
}

export { credentials }